<template>
  <div
    v-if="show"
    class="modal-exit"
    @keydown.esc="emit('close-dialog')"
  >
    <div class="modal-container">
      <!-- Header -->
      <div class="modal-header">
        <h2 class="modal-title">
          {{ t('logout_modal.title') }}
        </h2>
      </div>

      <!-- Message -->
      <div class="modal-message">
        {{ t('logout_modal.message') }}
      </div>

      <!-- Actions -->
      <div class="modal-actions">
        <GlobusButtonSecondary
          class="cancel-button"
          @click="emit('close-dialog')"
        >
          {{ t('logout_modal.button.cancel') }}
        </GlobusButtonSecondary>
        <GlobusButtonPrimary
          class="confirm-button"
          @click="exit"
        >
          {{ t('logout_modal.button.accept') }}
        </GlobusButtonPrimary>
      </div>
    </div>
  </div>
</template>

<script setup>
import { exit } from "@/composables/functionExit";
import { t } from "@/controllerLK/GlobusLocalization";
import GlobusButtonPrimary from "@/components/common/GlobusInput/GlobusButtonPrimary.vue";
import GlobusButtonSecondary from "../common/GlobusInput/GlobusButtonSecondary.vue";

const emit = defineEmits(["close-dialog"]);

defineProps({
  show: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped lang="scss">
.modal-exit {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  width: 315px;
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.modal-header {
  display: flex;
  justify-content: center;
}

.modal-title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
}

.modal-message {
  background: #F4FAFF;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 18px;
}

.modal-actions {
  display: flex;
  justify-content: space-between;
  gap: 11px;
}

.cancel-button, .confirm-button {
  width: 138px;
}
</style>
